import styled from "styled-components";

export const Ul = styled.ul`
  list-style-type: none;
  padding: 0; 
  margin-top:0px;
`;
export const Li = styled.li`
  position: relative;  
`;